import React from 'react';
import SettingsContainerView from '../../settings/SettingsContainerView';
import AdminApiView from './AdminApiView';
import AdminWebhooksView from './AdminWebhooksView';

const AdminDeveloperView = () => (
  <SettingsContainerView title="Developer" parentTitle="Developer">
    <AdminWebhooksView />
    <AdminApiView />
  </SettingsContainerView>
);

export default AdminDeveloperView;
